/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface MembershipRequest { 
    /**
     * Gets or sets the name.
     */
    Name: string;
    /**
     * Gets or sets the description.
     */
    Description: string;
    /**
     * Gets or sets the stripe product identifier.
     */
    StripeProductId: string;
    /**
     * Gets or sets the stripe price identifier.
     */
    StripePriceId: string;
    /**
     * Gets or sets the price.
     */
    Price: number;
    /**
     * Gets or sets the currency symbol.
     */
    CurrencySymbol: string;
}

